import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=f612add2&"
import script from "./UserDropdown.vue?vue&type=script&lang=js&"
export * from "./UserDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports